'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _businessDetails = require('./business-details.component');

var _businessDetails2 = _interopRequireDefault(_businessDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var businessDetailsModule = _angular2.default.module('app.containers.business-details', []).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('businessDetails', {
    url: '/businesses/:businessId',
    template: '<business-details></business-details>'
  });
}).component('businessDetails', _businessDetails2.default);

exports.default = businessDetailsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/business-details/business-details.js
 **/